// Dismissible warning shown only inside in-app browsers (no camera/GPS).
import { el } from "../lib/dom";
import { isInAppBrowser } from "../lib/permissions";

export function webviewBanner(): HTMLElement | null {
  if (!isInAppBrowser()) return null;
  const banner = el(
    "div.card",
    { style: "border-color:var(--amber);background:#1a1206" },
    el("span.card__tag", {}, "COMPROMISED CHANNEL"),
    el("p.tiny.amber", {}, "⚠ Open in Safari/Chrome for full field kit (camera + GPS)."),
  );
  const dismiss = el(
    "button.btn.btn--ghost.btn--sm",
    { style: "margin-top:6px", onclick: () => banner.remove() },
    "Dismiss",
  );
  banner.append(dismiss);
  return banner;
}
